import { render, staticRenderFns } from "./ProductMore.vue?vue&type=template&id=6a00d252&scoped=true"
import script from "./ProductMore.vue?vue&type=script&lang=js"
export * from "./ProductMore.vue?vue&type=script&lang=js"
import style0 from "./ProductMore.vue?vue&type=style&index=0&id=6a00d252&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a00d252",
  null
  
)

export default component.exports